import {ImageDtoSourceEnum} from "../gen/client";

export enum MenuItemType {
  ITEM, SECTION
}

export class MenuItemData {
  id: string;
  name: string;
  description: string;
  preview: string;
  price: string;
  type: MenuItemType;
  modifiers: MenuItemModifier[];
  extras: string;

  constructor(id: string, type: MenuItemType = MenuItemType.ITEM) {
    this.id = id;
    this.type = type;
  }
}

export enum MenuNodeType {
  SECTION, ITEM
}

export class MenuNode {
  id: string;
  name: string;
  description: string;
  cookTime: string;
  preview: string;
  previewSource: ImageDtoSourceEnum;
  previewAltText: string;
  icons: MenuItemIcon[];
  type: MenuNodeType;
  nodes: MenuNode[];
  prices: string[];
  sizes: string[];
  available: boolean;
  modifiers: MenuItemModifier[];
  extras: string;

  constructor(id: string, type: MenuNodeType = MenuNodeType.SECTION, prices: string[] = [], available: boolean = true, modifiers: MenuItemModifier[] = [], extras: string = '') {
    this.id = id;
    this.type = type;
    this.nodes = [];
    this.prices = prices;
    this.sizes = [];
    this.available = available;
    this.modifiers = modifiers;
    this.extras = extras;
  }
}

export class MenuItemModifier {
  id: string;
  name: string;
  entries: MenuItemModifierEntry[];
  sequence: number;

  constructor(id: string, name: string = '', entries: MenuItemModifierEntry[] = [], sequence = -1) {
    this.id = id;
    this.name = name;
    this.entries = entries;
    this.sequence = sequence;
  }
}

export class MenuItemIcon {
  type: string;
  iconKey: string;
  hoverText: string;
  path?: string;
  altText: string;
  source?: string;

  constructor(type: string = '', iconKey: string = '', hoverText: string = '', path: string = '', altText: string = '', source: string = '') {
    this.type = type;
    this.iconKey = iconKey;
    this.hoverText = hoverText;
    this.path = path;
    this.altText = altText;
    this.source = source;
  }
}

export class MenuItemModifierEntry {
  id: string;
  name: string;
  price: string;
  sequence: number;

  constructor(id: string, name: string = '', price: string = '', sequence = -1) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.sequence = sequence;
  }
}
